import { Api, ApiRequest, ResType } from '@api'
import { Logger } from '@utils'

export const addMenu = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/menu'
		const req = new ApiRequest({
			method: 'post',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const getMenu = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/menu'
		const req = new ApiRequest({
			method: 'get',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const updateMultipleMenu = async ({
	params = {},
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = '/menu/batch-update'
		const req = new ApiRequest({
			method: 'put',
			uri: uri,
			body: body,
			query: query,
			customHeaders: customHeaders,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const deleteMenu = async ({
	params = { id: '' },
	body = {},
	query = {},
	customHeaders = {},
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/menu/${params.id}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

export const batchDeleteMenu = async ({
	params = {},
	body = {},
	query = { menu_ids: '' },
	customHeaders = { menu_ids: '' },
} = {}): Promise<ResType | undefined> => {
	try {
		const uri = `/menu?menu_ids=${query.menu_ids}`
		const req = new ApiRequest({
			method: 'delete',
			uri: uri,
		})

		const result: ResType = await Api.connection(req)

		return result
	} catch (error) {
		Logger.warn(error)
		return undefined
	}
}

const menuApi = {
	addMenu: addMenu,
	getMenu: getMenu,
	updateMultipleMenu: updateMultipleMenu,
	deleteMenu: deleteMenu,
	batchDeleteMenu: batchDeleteMenu,
}

export default menuApi
